import { get } from 'lodash'

export default function(fields, orgId) {
  return {
    activityCategoryId: get(fields, 'activityCategory.id'),
    orgId,
    email: get(fields, 'email'),
    title: get(fields, 'title'),
    firstName: get(fields, 'firstName'),
    middleName: get(fields, 'middleName'),
    lastName: get(fields, 'lastName')
  }
}
